"use client"

import { css, fresponsive, styled } from "library/styled"
import type { Dispatch, SetStateAction } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"
import { FilterCheckBox } from "./FilterCheckbox"

interface CategoriesProps {
	items: { categories?: string[] | undefined }[]
	filterWords: string[]
	setFilterWordsAction: Dispatch<SetStateAction<string[]>>
	setLastUpdatedAction: Dispatch<SetStateAction<"searchValue" | "filterWords">>
	lastUpdated: "searchValue" | "filterWords"
}

export function Categories({
	items,
	filterWords,
	setFilterWordsAction,
	setLastUpdatedAction,
	lastUpdated,
}: CategoriesProps) {
	const uniqueCategories = Array.from(
		new Set(items.flatMap((item) => item?.categories ?? [])),
	)

	const handleClearAll = () => {
		setFilterWordsAction([])
		setLastUpdatedAction("filterWords")
	}

	return (
		<Wrapper>
			{uniqueCategories.map((category) => (
				<FilterCheckBox
					key={category}
					category={category}
					filterWords={filterWords}
					setFilterWordsAction={setFilterWordsAction}
					setLastUpdatedAction={setLastUpdatedAction}
					lastUpdated={lastUpdated}
				/>
			))}
			{filterWords.length > 0 && (
				<ClearButton type="button" onClick={handleClearAll}>
					Clear All Filters
				</ClearButton>
			)}
		</Wrapper>
	)
}

const Wrapper = styled(
	"div",
	fresponsive(css`
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		align-items: center;
	`),
)

const ClearButton = styled(
	"button",
	fresponsive(css`
		${textStyles.titleS};
		color: ${colors.green300};
		background: none;
		border: none;
		cursor: pointer;
		text-decoration: underline;
		padding: 0;
		margin-left: 8px;

		&:hover {
			color: ${colors.green500};
		}
	`),
)
